import { Component } from '@angular/core';

@Component({
  selector: 'app-media-mentions',
  templateUrl: './media-mentions.component.html',
  styleUrls: ['./media-mentions.component.css']
})
export class MediaMentionsComponent {

  mentions=[
    {
      description: "<p>Should you buy Bajaj Capital's coronavirus health policy that pays a lump sum to surviving insured?</p>\r\n",
      icon_image: "https://image.bajajcapitalone.com/bajajcapital/ET%20Logo.png",
      title: "ET"
    },
    {
      description: "<p>MF investment in equity markets rises to Rs 39,500-cr in H1 2020 on attractive valuations.</p>\r\n",
      icon_image: "https://image.bajajcapitalone.com/bajajcapital/TOI%20Logo.png",
      title: "TOI"
    },
    {
      description: "<p>Corporate FDs still attractive for seniors despite interest rate cuts</p>\r\n",
      icon_image: "https://image.bajajcapitalone.com/bajajcapital/ET%20Logo_0.png",
      title: "ET"
    },
    {
      description: "<p>Corporate FDs still attractive for seniors despite interest rate cuts</p>\r\n",
      icon_image: "https://image.bajajcapitalone.com/bajajcapital/ET%20Logo_0.png",
      title: "ET"
    }
  ]

}
